import { KeyboardShortcutDefinition } from './redux/types';

export const SHORTCUT_PANEL_SHORTCUT: KeyboardShortcutDefinition = {
	id: 'TOGGLE_SHORTCUTS_PANEL',
	name: 'Open keyboard shortcuts panel',
	initialKeys: 'ctrl+h',
	triggersInInputs: true,
	triggersInTextareas: true,
	isDesactivatable: false,
};

export const SHORTCUT_SPOTLIGHT_SHORTCUT: KeyboardShortcutDefinition = {
	id: 'TOGGLE_SHORTCUTS_SPOTLIGHT',
	name: 'Spotlight',
	initialKeys: 'ctrl+space',
	triggersInInputs: true,
	isDesactivatable: false,
};
export const SHORTCUT_VOICE_SHORTCUT: KeyboardShortcutDefinition = {
	id: 'START_VOICE_SHORTCUT',
	name: 'Start voice shortcut',
	initialKeys: 'ctrl+shift',
	triggersInInputs: true,
};
export const SHORTCUT_MANAGER_SHORTCUTS: KeyboardShortcutDefinition[] = [
	SHORTCUT_PANEL_SHORTCUT,
	SHORTCUT_SPOTLIGHT_SHORTCUT,
	SHORTCUT_VOICE_SHORTCUT,
];
